import SmartRegistrationDashboard from "./subcomponents/SmartRegistrationDashboard";


const SmartRegistration = () => {
    return (
        <>
            <SmartRegistrationDashboard/>
        </>
    )
}

export default SmartRegistration;